module.exports = __webpack_public_path__ + "prod/1.42.2/img/footertwo.ebac1d58.png";